import React from 'react'
import { Label, Switch } from '@/shared/ui'
import { useAnalysisCourtesyStatus } from '../hooks/useAnalysisCourtesyStatus'

type AnalysisCourtesyFieldProps = {
  visible: boolean
  value: boolean
  linkedOpportunityId: number | null
  disabled?: boolean
  onChange: (next: boolean) => void
}

export function AnalysisCourtesyField({
  visible,
  value,
  linkedOpportunityId,
  disabled,
  onChange,
}: AnalysisCourtesyFieldProps) {
  const { status, loading } = useAnalysisCourtesyStatus(visible)

  if (!visible) return null

  const unlimited = status?.courtesyUnlimited ?? false
  const used = status?.courtesyUsed ?? 0
  const limit = status?.courtesyLimit ?? 0
  const remaining =
    status?.courtesyRemaining ?? Math.max((limit || 0) - (used || 0), 0)

  const usageLabel = unlimited ? `Usadas neste mes: ${used} (Ilimitado)` : `Usadas neste mes: ${used}/${limit}`
  const countBadge = unlimited ? 'Ilimitado' : `${used}/${limit}`
  const canEnable = unlimited || remaining > 0

  const switchDisabled =
    !!disabled || linkedOpportunityId == null || (!value && !canEnable) || loading

  return (
    <div className="rounded-md border border-border/60 px-3 py-2">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0 space-y-0.5">
          <div className="flex items-center gap-2">
            <Label>Cortesia</Label>
            <span className="rounded-full border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 text-[10px] font-medium text-amber-200">
              {countBadge}
            </span>
          </div>
          <p className="text-xs text-foreground/60">
            Ao ativar, esta analise fica visivel para todos os planos, mesmo sem acesso a moeda.
          </p>
          <p className="text-xs text-foreground/60">{usageLabel}</p>
          {!unlimited && remaining <= 0 && (
            <p className="text-xs text-amber-200">
              Limite mensal de cortesias atingido.
            </p>
          )}
        </div>
        <Switch
          checked={value}
          disabled={switchDisabled}
          onChange={(e) => onChange((e.target as HTMLInputElement).checked)}
        />
      </div>
    </div>
  )
}
